import {
  InteractionStepType,
  ChatApiEndpointWithId,
  DEFAULT_SEARCH_AUTOCOMPLETE_TITLE,
  DEFAULT_SEARCH_AUTOCOMPLETE_SUBTITLE,
  ProjectChatApiEndpointWithId,
} from '@scale/shared/types/chat';
import StringInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/StringInputBuilder';
import ChatApiEndpointsBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ChatApiEndpointsBuilder';
import BooleanInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/BooleanInputBuilder';
import {
  ConditionalStepConfig,
  ReviewLevelConfig,
} from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/configs';
import { StepConfigurationComponentProps } from '../../stepDescriptor/types';

const SearchAutoCompleteConfigurationComponent = ({
  params: currentParams,
  setParams: setCurrentParams,
  previousParams,
  taskParams,
}: StepConfigurationComponentProps<InteractionStepType.SearchAutoComplete>) => {
  return (
    <div className="flex flex-col gap-4">
      <StringInputBuilder
        name={'Title'}
        placeholder={DEFAULT_SEARCH_AUTOCOMPLETE_TITLE}
        existingValue={currentParams.title}
        updateProperty={(value: string) => setCurrentParams({ ...currentParams, title: value })}
        required={true}
      />

      <StringInputBuilder
        name={'Subtitle'}
        placeholder={DEFAULT_SEARCH_AUTOCOMPLETE_SUBTITLE}
        existingValue={currentParams.subtitle}
        updateProperty={(value: string) => setCurrentParams({ ...currentParams, subtitle: value })}
      />

      <div className="flex flex-col gap-2">
        <ChatApiEndpointsBuilder
          existingValue={currentParams.params.chat_models}
          updateProperty={(value: Array<ChatApiEndpointWithId | ProjectChatApiEndpointWithId>) =>
            setCurrentParams({
              ...currentParams,
              params: { ...currentParams.params, chat_models: value },
            })
          }
          maxNumberOfEndpoints={1}
        />
      </div>

      <div className="flex flex-col gap-2">
        <BooleanInputBuilder
          name={'Make Additional References Optional'}
          existingValue={!!currentParams.params.make_additional_references_optional}
          updateProperty={(value: boolean) =>
            setCurrentParams({
              ...currentParams,
              params: { ...currentParams.params, make_additional_references_optional: value },
            })
          }
        />
        <div className="prose text-sm italic ml-8">
          If enabled, then users will be able to submit their response without selecting any
          additional references. One search snippet in the main reference must always be selected
          before continuing.
        </div>
      </div>

      <ReviewLevelConfig currentParams={currentParams} setCurrentParams={setCurrentParams} />
      <ConditionalStepConfig
        currentParams={currentParams}
        setCurrentParams={setCurrentParams}
        previousParams={previousParams}
        taskParams={taskParams}
      />
    </div>
  );
};

export default SearchAutoCompleteConfigurationComponent;
